import { render, staticRenderFns } from "./PublicHome.vue?vue&type=template&id=3202f707&scoped=true&"
import script from "./publicHome.ts?vue&type=script&lang=ts&"
export * from "./publicHome.ts?vue&type=script&lang=ts&"
import style0 from "./PublicHome.vue?vue&type=style&index=0&id=3202f707&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3202f707",
  null
  
)

export default component.exports